module.exports = __webpack_public_path__ + "fonts/931aebd.ttf";